import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container mt-4"
}
const _hoisted_2 = {
  key: 1,
  class: "container mt-4"
}
const _hoisted_3 = { class: "d-flex flex-column align-items-start gap-4 mb-4 w-100" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "d-flex gap-4 w-100"
}
const _hoisted_7 = { class: "fw-bold col-md-4" }
const _hoisted_8 = { class: "d-flex gap-4 w-100" }
const _hoisted_9 = { class: "fw-bold col-md-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex gap-4 w-100" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold col-md-4" }, "Primary Address:", -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "d-flex gap-4 w-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold col-md-4" }, "Email Address:", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "d-flex gap-4 w-100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold col-md-4" }, "Phone #:", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "d-flex flex-column gap-4 mb-4 w-100" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, "Contact Personnel (s)", -1)
const _hoisted_24 = { class: "table table-striped mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", null, " Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Designation "),
    /*#__PURE__*/_createElementVNode("th", null, " At Address "),
    /*#__PURE__*/_createElementVNode("th", null, " Phone "),
    /*#__PURE__*/_createElementVNode("th", null, " Start Date "),
    /*#__PURE__*/_createElementVNode("th", null, " End Date ")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "text-center"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("tr", { class: "align-middle text-center" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, " No Records")
], -1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.type) + " Profile ", 1),
          _createElementVNode("p", null, [
            _createTextVNode(" This page displays information about your company data on file with the Fund Office. "),
            ($setup.type === 'Local')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createTextVNode(" If any of this information needs to be changed or is incorrect, please click "),
                  _createVNode(_component_router_link, { to: { name: 'contact' } }, {
                    default: _withCtx(() => [
                      _createTextVNode(" here ")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" to email the Fund office. ")
                ]))
              : _createCommentVNode("", true)
          ]),
          ($setup.type === 'Local')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.type) + ":", 1),
                _createElementVNode("span", null, _toDisplayString($setup.localName), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contacts, (contact, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "d-flex flex-column align-items-start justify-content-between gap-2 w-100"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  ($setup.type === 'Local')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.type), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Name:")
                ]),
                _createElementVNode("span", null, _toDisplayString(contact?.OrgName), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", {
                  innerHTML: contact.Address
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                (contact.Emails)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.Emails, (email, key) => {
                        return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(email), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, " No Records "))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                (contact.Phones)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.Phones, (phone, key) => {
                        return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(phone), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, " No Records "))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("table", _hoisted_24, [
            _hoisted_25,
            ($setup.personnels.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.personnels, (personnel) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: personnel.PersonID,
                      class: "align-middle text-center"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(personnel.Name), 1),
                      _createElementVNode("td", null, _toDisplayString(personnel.Designation), 1),
                      _createElementVNode("td", {
                        innerHTML: personnel.AtAddress
                      }, null, 8, _hoisted_27),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personnel.Phones, (phone, key) => {
                          return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(key) + "# " + _toDisplayString(phone), 1))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(personnel.StartDate), 1),
                      _createElementVNode("td", null, _toDisplayString(personnel.EndDate), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_28, _hoisted_30))
          ])
        ])
      ]))
}